import React from "react";

import AttachFileIcon from "@mui/icons-material/AttachFile";
import DeleteIcon from "@mui/icons-material/Delete";
import DownloadIcon from "@mui/icons-material/Download";
import SyncIcon from "@mui/icons-material/Sync";

import { Attachment } from "@fartherfinance/frontend/api/Tasks/Types";

import { toClassName } from "@src/multiCustodian/utils/to-class-name";
import IconButton from "@src/sharedComponents/IconButton/IconButton";
import Text from "@src/sharedComponents/Typography/Text";

import styles from "./TaskAttachment.module.css";

interface TaskCommentAttachmentProps {
  attachment: Omit<Attachment, "id"> & Pick<Partial<Attachment>, "id">;
  isLoading: boolean;
  isAllowedToDelete: boolean;
  onRemove: () => void;
}

const TaskAttachment: React.FC<TaskCommentAttachmentProps> = ({
  attachment,
  isLoading,
  isAllowedToDelete,
  onRemove,
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <AttachFileIcon className={styles.icon} />

        <a
          href={attachment.previewUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Text variant="body">{attachment.filename}</Text>
        </a>
      </div>

      <div className={styles.actions}>
        {isAllowedToDelete ? (
          !isLoading ? (
            <IconButton
              size="small"
              iconClassName={styles.icon}
              onClick={onRemove}
              IconComponent={DeleteIcon}
            />
          ) : (
            <SyncIcon
              className={toClassName(styles.icon, styles.loadingIcon)}
            />
          )
        ) : null}
        <IconButton
          size="small"
          iconClassName={styles.icon}
          onClick={() => (window.location.href = attachment.downloadUrl)}
          IconComponent={DownloadIcon}
        />
      </div>
    </div>
  );
};

export default TaskAttachment;
